import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a:not([href])',
  host: {
    '[attr.role]': 'attrRole',
    '[attr.tabindex]': 'attrTabindex'
  }
})
export class LinkAccessibilityDirective {
  attrRole: string;
  attrTabindex: string;

  private readonly element = inject(ElementRef<HTMLAnchorElement>);

  constructor() {
    this.attrRole = this.element.nativeElement.getAttribute('role') ?? 'button';
    this.attrTabindex = this.element.nativeElement.getAttribute('tabindex') ?? '0';
  }
}